import api from '../api';
import { QUALITY_SERVICE_API_URL } from '../config';
import { createCachedResource } from './cachedResource';

const releaseRuns = createCachedResource(async (runId, replica) => {
  const response = await api.get(`${QUALITY_SERVICE_API_URL}/hub/sdk-performance/release/${encodeURIComponent(runId)}`, { params: { replica } });
  return response.data;
});

export const clearReleasePerformanceCache = releaseRuns.clear;

// One release performance run with what it is compared with. A missing run
// or a null replica asks for nothing.
function useReleasePerformance(runId, replica = 'all') {
  const key = runId === null || runId === undefined || replica === null ? null : JSON.stringify([String(runId), String(replica)]);
  return releaseRuns.useCachedResource(key, [runId, replica]);
}

export default useReleasePerformance;
